import React from "react";
import { Navigate, Route } from "react-router";
import OrderListPage from "pages/OrderPages/OrderListPage/OrderListPage";
import OrderDetailPage from "pages/OrderPages/OrderDetailPage/OrderDetailPage";
import { ProtectedRoute } from "./ProtectedRoute";
import { UserNavigationGroup, UserRole } from "../types/declarations/enums.ts";

export const MyOrdersRoutes = ProtectedRoute({
	blackListNavGroupWithRoles: {
		[UserNavigationGroup.QUOTER]: [UserRole.USER]
	},
	children: (
		<>
			<Route
				path="orders"
				element={<OrderListPage />}
			/>
			<Route
				path="projects"
				element={
					<Navigate
						to="/orders"
						replace
					/>
				}
			/>
			<Route
				path="details/:orderId"
				element={<OrderDetailPage />}
			/>
		</>
	)
});
